<template>
  <div class="site-detail-page">

    <!-- 主要内容区域 -->
    <div class="site-detail-container">
      <!-- 面包屑导航 -->
      <div v-if="error" class="error-message">
        {{ error }}
      </div>

      <div v-else-if="siteInfo">
        <!-- 上方区域：分为左右两个区块 -->
        <div class="upper-section">
          <!-- 左边区块：预览图 -->
          <div class="left-section">
            <div class="preview-container">
              <img
                :src="siteInfo.imageUrl"
                :alt="siteInfo.name"
                class="preview-image"
              />
              <div v-if="siteInfo.upFlag" class="diamond-tag">
                <i class="el-icon-basketball"></i>
                {{ siteInfo.upFlag }}
              </div>
            </div>
          </div>

          <!-- 右边区块：分为三行 -->
          <div class="right-section">
            <!-- 第一行：网站名称 -->
            <div class="site-name-row">
              <h1 class="site-title">{{ siteInfo.name }}</h1>
            </div>

            <!-- 第二行：网站描述 -->
            <div class="site-description-row">
              <p class="site-description" v-html="siteInfo.intro"></p>
            </div>

            <!-- 第三行：操作按钮 -->
            <div class="action-buttons-row">
              <div class="action-buttons">
                <el-button
                  type="primary"
                  @click="visitSite"
                  class="action-btn"
                  icon="el-icon-link"
                >
                  访问官网
                </el-button>
                <el-button
                    type="success"
                    @click="getAccount"
                    class="action-btn"
                    icon="el-icon-link"
                >
                  成品账号
                </el-button>

                <el-button
                  v-if="siteInfo && siteInfo.proxyRechargeUrl"
                  type="success"
                  @click="accountRecharge"
                  class="action-btn"
                  icon="el-icon-wallet"
                >
                  账号代充
                </el-button>
                <el-button
                  type="info"
                  @click="contactSupport"
                  class="action-btn"
                  icon="el-icon-service"
                >
                  联系客服
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 下方区域：网站介绍 -->
        <div class="lower-section">
          <div class="introduction-container">
            <div v-html="siteInfo.detail"></div>
          </div>
        </div>
      </div>
      <!-- </el-card> -->
    </div>

    <!-- 客服对话框 -->
    <el-dialog
        title="联系客服"
        :visible.sync="supportDialogVisible"
        width="500px"
    >
      <!-- 直接展示后台返回的二维码图片 -->
      <div class="qrcode-container" style="text-align:center;">
        <img
            v-if="siteInfo && siteInfo.qrcodeUrl"
            :src="siteInfo.qrcodeUrl"
            alt="微信客服二维码"
            style="width:200px;height:200px;object-fit:contain;"
        />
        <div v-else style="color:#999;">暂无二维码</div>
      </div>

      <p>1. 扫码添加微信客服</p>
      <p>2. 联系客服 购买成品账号 或 账号代充</p>

      <div class="qrcode-footer" style="text-align:right;">
        <el-button
            @click="supportDialogVisible = false"
            type="primary"
            class="close-btn"
        >关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { siteApi } from "@/utils/api";
import QRCode from "qrcodejs2";

export default {
  name: "SiteDetailPage",
  data() {
    return {
      siteInfo: null,
      loading: true,
      error: null,
      rechargeDialogVisible: false,
      supportDialogVisible: false,
      qrCodeInstance: null, // 用于存储二维码实例
      rechargeForm: {
        type: "",
        account: "",
        quantity: 1,
        remark: "",
      },
      supportForm: {
        type: "",
        description: "",
      },
      rechargeTypes: [
        { id: 1, name: "VIP会员" },
        { id: 2, name: "积分充值" },
        { id: 3, name: "道具购买" },
      ],
      supportTypes: [
        { id: 1, name: "网站访问问题" },
        { id: 2, name: "账号充值问题" },
        { id: 3, name: "功能建议" },
        { id: 4, name: "其他问题" },
      ],
    };
  },
  created() {
    const [siteId, token] = this.$route.query.websiteId.split("_");
    this.websiteId = siteId;
    this.token = token;
    if (this.websiteId) {
      this.fetchSiteDetail(this.websiteId);
    } else {
      this.error = "缺少站点参数";
      this.loading = false;
    }
  },
  methods: {
    async fetchSiteDetail(siteId) {
      try {
        const response = await siteApi.getSiteDetail(siteId);
        this.siteInfo = response.data;
        this.loading = false;
      } catch (error) {
        this.error = "获取站点详情失败: " + error.message;
        this.loading = false;
      }
    },
    async visitSite() {
      if (!this.siteInfo) return;

      // 检查浏览器访问权限
      try {
        const accessResponse = await siteApi.checkWebsiteAccess({
          websiteId: this.websiteId,
          token: this.token,
        });
        if (accessResponse.code !== 0) {
          // 如果返回码不为0，提示错误信息
          this.$message.warning(accessResponse.msg || "访问权限不足，请联系客服");
          return;
        }

        // 如果已登录，新打开一个浏览器窗口跳转到站点详情
        window.open(this.siteInfo.targetUrl, "_blank");
      } catch (error) {
        console.log(error);
        this.$message.error("访问权限不足，请联系客服");
      }
    },
    async getAccount(){
      const { href } = this.$router.resolve({
        path: '/recharge',
        query: { token: this.token }
      });
      window.open(href, '_blank', 'noopener'); // 新标签页打开
    },
    accountRecharge() {
      if (this.siteInfo && this.siteInfo.proxyRechargeUrl) {
        // 如果存在proxyRechargeUrl，则跳转到该URL
        window.open(this.siteInfo.proxyRechargeUrl, "_blank");
      } else {
        // 否则使用默认的跳转逻辑
        this.$message.info("即将跳转到代充页面，请稍候...");
        setTimeout(() => {
          this.$router.push("/proxy-recharge");
        }, 1000); // 延迟1秒后跳转
      }
    },
    contactSupport() {
      this.supportDialogVisible = true;
    },
    // 生成二维码
    generateQRCode() {
      // 清除已存在的二维码实例
      if (this.qrCodeInstance) {
        this.qrCodeInstance.clear();
        this.qrCodeInstance.makeCode(this.siteInfo.qrcodeUrl);
        return;
      }

      // 创建新的二维码
      this.$nextTick(() => {
        const qrCodeElement = document.getElementById("qrcode");
        if (qrCodeElement && this.siteInfo && this.siteInfo.qrcodeUrl) {
          this.qrCodeInstance = new QRCode(qrCodeElement, {
            text: this.siteInfo.qrcodeUrl,
            width: 200,
            height: 200,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
        }
      });
    },
    confirmRecharge() {
      this.$message.success("充值请求已提交，请等待客服处理！");
      this.rechargeDialogVisible = false;
      // 重置表单
      this.rechargeForm = {
        type: "",
        account: "",
        quantity: 1,
        remark: "",
      };
    },
    submitSupport() {
      this.$message.success("问题已提交，客服会尽快与您联系！");
      this.supportDialogVisible = false;
      // 重置表单
      this.supportForm = {
        type: "",
        description: "",
      };
    },
    goToHome() {
      this.$router.push("/hot-sites");
    },
  },
  beforeDestroy() {
    // 清除二维码实例
    if (this.qrCodeInstance) {
      this.qrCodeInstance.clear();
      this.qrCodeInstance = null;
    }
  },
};
</script>

<style scoped>
.site-detail-page {
  height: 100vh;
  background-color: #f5f5f5;
  overflow-y: auto;
  scrollbar-width: thin;
}

.site-detail-header {
  background-color: #409eff;
  color: white;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 20px;
}

.logo h1 {
  margin: 0;
  font-size: 24px;
  cursor: pointer;
}

.site-detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.breadcrumb {
  margin-bottom: 20px;
  background-color: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.main-card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.error-message {
  text-align: center;
  padding: 50px;
  color: #f56c6c;
}

.upper-section {
  display: flex;
  margin-bottom: 30px;
  min-height: 200px;
}

.left-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.preview-container {
  width: 100%;
  max-width: 100%;
  /* height: 180px; */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.preview-image {
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.diamond-tag {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #409eff;
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  border-bottom-left-radius: 4px;
  display: flex;
  align-items: center;
  gap: 3px;
}

.diamond-tag i {
  font-size: 12px;
}
/* 保持原有样式不变 */

.right-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.site-title {
  font-size: 24px;
  margin: 0 0 10px 0;
  color: #333;
}

.site-description {
  font-size: 16px;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.5;
  align-self: flex-start;
}

.action-buttons-row {
  margin-top: auto;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.action-btn {
  flex: 1;
}

.lower-section {
  border-top: 1px solid #ebeef5;
  padding-top: 20px;
}

.introduction-container {
  line-height: 1.6;
}

.qr-code {
  width: 200px;
  height: 200px;
  display: block;
  margin: 0 auto;
}

.qrcode-tip {
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  color: #606266;
  font-weight: 500;
}

.qrcode-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

#qrcode {
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.qrcode-footer {
  text-align: center;
}

.close-btn {
  width: 120px;
}
</style>
